/**
 * Fiskal Cloud Usage API
 * # Overview Retrieve usage reports for billing.  # Usage The export of reporting data can be triggered on tenant, organization or business premises level. In addition an overall usage report based on customer Identifier (from billing system) or for all customers can be requested.  Report is always based on a specific month.  ## Getting an authentication token  To be able to work with the API you need to get an authentication token to use with all subsequent API calls described below. Get the token via the [Oauth endpoint](https://fiskal.cloud/auth/realms/df/protocol/openid-connect/token) of the Fiskal Cloud. Use client_id=df-api and grant_type=password for requesting a token. > The access token grants same access rights as the user has in the Fiskal Cloud Portal.  Example request to get token via curl: ``` curl -X POST \\ https://fiskal.cloud/auth/realms/df/protocol/openid-connect/token \\ -H \'Accept: application/json\' \\ -H \'Content-Type: application/x-www-form-urlencoded\' \\ -d \'username=<USER_EMAIL_ADDRESS>&password=<USER_PASSWORD>&client_id=df-api&grant_type=password\' ``` Save the access_token entry of the response and pass it as bearer token in all subsequent API calls. Pass it as header parameter. ```\'Authorization: Bearer <ACCESS_TOKEN_FROM_AUTHENTICATION>\'```  For details on access tokens, please check general Oauth documentation like [Oauth.com](https://www.oauth.com/oauth2-servers/access-tokens/access-token-response/) 
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: info@deutsche-fiskal.de
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { UsageItemDTO } from './usage-item-dto';


export interface UsageDTO { 
    /**
     * Start of usage period returned
     */
    periodStart?: string;
    /**
     * End of usage period returned
     */
    periodEnd?: string;
    data?: Array<UsageItemDTO>;
}

export class ClsUsageDTO { 
    /**
     * Start of usage period returned
     */
    periodStart?: string = undefined;
    /**
     * End of usage period returned
     */
    periodEnd?: string = undefined;
    data?: Array<UsageItemDTO> = undefined;
}

